import { StepConfigItem } from '~/Interfaces';
import { CardPurpose } from '~/pages/CardApplication/components/Steps/components/CardPurpose/CardPurpose';
import { CompanySelector } from '~/pages/CardApplication/components/Steps/components/CompanySelector/CompanySelector';
import { PersonalInformation } from '~/pages/CardApplication/components/Steps/components/PersonalInformation/PersonalInformation';

const CompanySelectorStep: StepConfigItem = {
  component: CompanySelector,
  header: {
    title: 'CardApplication.SelectCompanyStepTitle',
    description: 'CardApplication.SelectCompanyStepDescription',
  },
  name: 'company_selector_step',
};

const CardPurposeStep: StepConfigItem = {
  component: CardPurpose,
  header: {
    title: 'CardApplication.SelectPurposeStepTitle',
    description: 'CardApplication.SelectPurposeStepDescription',
  },
  name: 'card_purpose_step',
};

const PersonalInformationStep: StepConfigItem = {
  component: PersonalInformation,
  header: {
    title: 'CardApplication.PersonalInformationStepTitle',
    description: 'CardApplication.PersonalInformationStepDescription',
  },
  name: 'personal_information_step',
};

export const cardApplicationSteps = [
  CompanySelectorStep,
  CardPurposeStep,
  PersonalInformationStep,
];
